module.exports = __webpack_public_path__ + "static/media/checkmark_active.54a01d62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/checkmark_active.svg
// module id = 68
// module chunks = 0